export var VALUES_NESTED = 'nested';
export var VALUES_PLAIN = 'plain';

export var editingConfig = {
  valuesMode: VALUES_NESTED
};